import { render } from "./BilanFormationSynthese.vue?vue&type=template&id=defeb1e2"
import script from "./BilanFormationSynthese.vue?vue&type=script&lang=js"
export * from "./BilanFormationSynthese.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__